
import React, { useEffect } from 'react';
import '../style/App.css';
import { useAuth0 } from '@auth0/auth0-react';
import { useTwitterContext } from '../TwitterContext';
import { useParams } from "react-router-dom";
import Header from './Header';
import Comment from './Comment';
import Tweet from './Tweet';
import { useNavigate } from 'react-router-dom';

const Detail = () => {
  const { tweetId } = useParams();
  const { loginWithRedirect } = useAuth0();
  const { accessToken, curUser } = useTwitterContext();
  const [curTweet, setCurTweet] = React.useState(null);
  const [user, setUser] = React.useState(null);
  const [comment, setComment] = React.useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function getTweet() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/tweets/${tweetId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await data.json();
      setCurTweet(result);
      setUser(result.user);
    }
    getTweet();
  }, [tweetId]);

  useEffect(() => {
    console.log("Detail updated");
  }, [curTweet, navigate]);

  const handleInputChange = (e) => {
    if (e.target.value.length > 280) {
      alert("Comment is too long!");
      return;
    }
    setComment(e.target.value);
  };

  const HandleReplyButtonClick = async () => {
    try {
      if (!curUser) {
        loginWithRedirect();
        return;
      } else if (curTweet === null) {
        return;
      } else if (comment.length === 0) {
        alert("Comment is empty!");
        return;
      }
      // Reply the tweet
      const data = await fetch(`${process.env.REACT_APP_API_URL}/comments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          userId: curUser.id,
          tweetId: curTweet.id,
          text: comment,
        }),
      });
      // refresh this component
      const result = await data.json();
      document.getElementById("comment-input-text").value = "";
      setComment("");
      let newTweet = curTweet;
      newTweet.comments = [...newTweet.comments, result];
      setCurTweet(newTweet);
    }  catch (error) {
      console.error('Error handling like:', error);
      // Handle error as needed
    }
  }

  const onTweetDelete = () => {
    navigate("/");
  }

  if (curTweet === null) {
    return null;
  }
  return (
    <div className="content-container">
      <Header />
      <div className="App">
        <Tweet tweet={curTweet} user={user} onDelete={onTweetDelete}/>
        <div className="comment-input">
          <input className="comment-input-text" placeholder="Post your reply" onChange={handleInputChange} id="comment-input-text"/>
          <button className="comment-input-button" onClick={HandleReplyButtonClick}>Reply</button>
        </div>
        <div className="comment-container">
          {curTweet.comments.map((comment) => (
            <Comment key={comment.id} comment={comment} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Detail;